<template>
  <section class="certified">
    <h2>{{ $t("certifiedTitle") }}</h2>
    <p class="certified__description">{{ $t("certifiedDescription") }}</p>
    <div class="certified__airlines">
      <div v-for="airline in airlines" :key="airline.name" class="certified__airline">
        <img :src="airline.logo" :alt="airline.name" loading="lazy" decoding="async">
        <p v-html="airlineDetails(airline.name)"></p>
      </div>
    </div>
    <div class="certified__iata">
       <img src="../images/certified/IATA.png" alt="IATA" loading="lazy" decoding="async">
       <h3>{{ $t("iataTitle") }}</h3>
       <p>{{ $t("iataDescription") }}
         <a target="_blank" href="https://retailing.iata.org/armi/registry/drct/">{{ $t("iataLink") }}</a>
       </p>
    </div>
  </section>
</template>

<script>
import aegeanLogo from '../images/certified/A3.svg';
import airBalticLogo from '../images/certified/BT.svg';
import americanLogo from '../images/certified/AA.svg';
import austrianLogo from '../images/certified/OS.svg';
import britishAirwaysLogo from '../images/certified/BA.svg';
import emiratesLogo from '../images/certified/EK.svg';
import flydubaiLogo from '../images/certified/FZ.svg';
import iberiaLogo from '../images/certified/IB.svg';
import lotLogo from '../images/certified/LO.svg';
import lufthansaLogo from '../images/certified/LH.svg';
import swissLogo from '../images/certified/LX.svg';
import tapLogo from '../images/certified/TP.svg';
import unitedLogo from '../images/certified/UA.svg';
import liveLogo from '../images/certified/LIVE.svg';
import implementationLogo from '../images/certified/IMPL.svg';

export default {
  data(){
    return {
      airlines: [
        { logo: aegeanLogo, name: "Aegean Airlines" },
        { logo: airBalticLogo, name: "airBaltic" },
        { logo: americanLogo, name: "American Airlines" },
        { logo: austrianLogo, name: "Austrian Airlines" },
        { logo: britishAirwaysLogo, name: "British Airways" },
        { logo: emiratesLogo, name: "Emirates" },
        { logo: flydubaiLogo, name: "flydubai" },
        { logo: iberiaLogo, name: "Iberia" },
        { logo: lotLogo, name: "LOT" },
        { logo: lufthansaLogo, name: "Lufthansa" },
        { logo: swissLogo, name: "SWISS" },
        { logo: tapLogo, name: "TAP" },
        { logo: unitedLogo, name: "United Airlines" },
        { logo: liveLogo, name: "+30 airlines in LIVE" },
        { logo: implementationLogo, name: "We are currently implementing +10 airlines" }
      ]
    }
  },
  methods: {
    airlineDetails(name){
      let info = name

      if (name == "+30 airlines in LIVE") {
        info = this.$i18n.t('live')
      } else if (name == "We are currently implementing +10 airlines") {
        info = this.$i18n.t('impl')
      }

      return info
    }
  }
}
</script>

<style lang="scss" scoped>
.certified {
  padding-top: 100px;

  h2 {
    font-size: 31px;
    font-weight: bold;
    text-align: center;
    color: rgb(27, 39, 51);

    @media (max-width: 413px) {
      font-size: 27px;
    }
  }
}

.certified__description {
  opacity: 0.9;
  font-size: 14px;
  line-height: 1.57;
  text-align: center;
  color: rgba(27, 39, 51, .9);
  margin-top: 10px;

  @media (max-width: 767px) {
    width: 350px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 413px) {
    width: 100%;
  }
}

.certified__airlines {
  width: 521px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  justify-content: center;
  column-gap: 28px;
  row-gap: 40px;
  margin: 40px auto 0;

  @media (max-width: 767px) {
    width: 314px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 24px;
    column-gap: 25px;
    row-gap: 25px;
  }

  @media (max-width: 413px) {
    width: 80%;
    column-gap: auto;
  }
}

.certified__airline {
  justify-self: center;
  width: 85px;
  height: 85px;
  position: relative;
  cursor: pointer;


  @media (max-width: 767px) {
    width: 54px;
    height: 54px;

    p {
      display: none;
    }
  }

  img {
    @media (max-width: 767px) {
      width: 54px;
      height: 54px;
    }
  }

  p {
    font-size: 13px;
    text-align: center;
    white-space: break-spaces;
    color: rgb(27, 39, 51);
    position: absolute;
    width: 100%;
    line-height: 17px;
    width: 123px;
    margin-left: -19px;
    opacity: 0;
    transition: .1s opacity;

    @media (max-width: 767px) {
      opacity: 1;
      width: 82px;
      margin-left: -14px;
      font-size: 12px;
      line-height: normal;
    }
  }

  &:hover {
    p {
      transition: .2s opacity;
      opacity: 1;
    }
  }
}

.certified__iata {
  display: flex;
  justify-content: center;
  flex-direction: column;

  img {
    margin-top: 78px;
    width: 84px;
    margin-left: auto;
    margin-right: auto;
  }

  h3 {
    font-size: 17px;
    font-weight: bold;
    color: rgb(27, 39, 51);
    margin-top: 20px;
    text-align: center;
  }

  p {
    font-size: 14px;
    line-height: 1.57;
    text-align: center;
    margin-top: 8px;
    color: rgba(27, 39, 51, .9);

    a {
      font-size: 14px;
      line-height: 1.57;
      color: rgba(42, 138, 234, .85);
      border-bottom: 1px solid rgba(42, 138, 234, .2);
      text-decoration: none;

      &:hover, a:active {
       color: rgba(42, 138, 234, 1);
       border-bottom: 1px solid rgba(42, 138, 234, .4);
      }
    }
  }
}
</style>
